import { createApp } from 'vue';
import { createPinia } from 'pinia';
import './base.css';
import App from './App.vue';
import router from './router';
import i18n from './utils/i18n';
import { useUserStore } from '@/store/userStore';
import { useFeatureStore } from '@/store/featureStore';

const pinia = createPinia();
const app = createApp(App);
app.use(i18n);
app.use(pinia);

useFeatureStore().init();

// Initialize authentication before the router checks protected routes.
const userStore = useUserStore();
userStore.setKeycloakInstance().then(() => {
  app.use(router);
  app.mount('#app');
});
